import React from 'react';

import scss from './MediaCard.module.scss';

function Video({ src, alt }) {
  return (
    <video src={src} alt={alt} className={scss.video} controls preload='metadata' loading='lazy'>
      <track kind='captions' />
    </video>
  );
}

export default Video;
